/***************************************************************************************************
** isTrue
***************************************************************************************************/

const DATA_TYPE_VALUES = {
  integer: {
    true: 1,
    false: 0,
  },
  string: {
    true: "true",
    false: "false",
  },
};

export default function isTrue(value, { fallback = false, dataType = undefined } = {}) {
  if (typeof value === "boolean") return value;

  if (dataType && DATA_TYPE_VALUES[dataType]) {
    const trueValue = DATA_TYPE_VALUES[dataType]["true"];
    return value === trueValue;
  }

  const stringValue = String(value).trim().toLowerCase();
  return stringValue === "true" ? true : fallback;
}
